import axios from 'axios'

/**
 * 网站配置平台 axios 实例。
 * baseURL 见 VUE_APP_WEB_CONFIG_BASE_URL（本地开发可指向 devServer 代理前缀）。
 */
export const webConfigHttp = axios.create({
  baseURL: process.env.VUE_APP_WEB_CONFIG_BASE_URL || '',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
})

webConfigHttp.interceptors.request.use((config) => {
  const secretKey = process.env.VUE_APP_WEB_CONFIG_SECRET_KEY
  const scene = process.env.VUE_APP_WEB_CONFIG_SCENE || 'test'
  if (secretKey) {
    const authorization = { secretKey, scene }
    if (!config.headers) {
      config.headers = {}
    }
    // 文档以对象描述 Authorization；HTTP 头只能是字符串，此处序列化与文档结构一致。
    config.headers.Authorization = JSON.stringify(authorization)
  }
  return config
})
